'use strict';

angular
	.module('dcApp')
	.controller('ConnectorListController', [
		'$log',
		'$scope',
		'$rootScope',
		'$state',
		'toaster',
		'ConnectorService',
		'ConnectorV2Service',
		'$q',
		'PermissionService',
		'API_BASE_URL_BACKEND',
		'gettext',
		'gettextCatalog',
		'DcElementListService',
		function (
			$log,
			$scope,
			$rootScope,
			$state,
			toaster,
			ConnectorService,
			$q,
			PermissionService,
			API_BASE_URL_BACKEND,
			gettext,
			gettextCatalog,
			DcElementListService
		) {
			const HTTP_CONNECTOR = 'HTTP';
			const SQL_CONNECTOR = 'SQL';
			const SFTP_CONNECTOR = 'SFTP';
			const S3_CONNECTOR = 'S3';
			const HDFS_CONNECTOR = 'HDFS';
			const MONGODB_CONNECTOR = 'MONGODB';
			const NEO4J_CONNECTOR = 'NEO4J';
			const TRINO_CONNECTOR = 'TRINO';

			let toasterPopSuccess = gettextCatalog.getString('Succès');
			let toasterPopDeleteConnectors = gettextCatalog.getString(
				'Suppression des Connecteurs effectuée'
			);
			let toasterPopDeleteConnector = gettextCatalog.getString(
				'Suppression du Connecteur'
			);
			let toasterPopDeleteConnectorSuccess =
				gettextCatalog.getString('effectuée');
			let toasterPopDeleteConnectorDB =
				gettextCatalog.getString('Base de données');

			$scope.API_BASE_URL_BACKEND = API_BASE_URL_BACKEND;
			$scope.currentProjectId = $rootScope.currentProjectId;
			$scope.showCurrentProjectOnly = true;
			$scope.activeElementsOnly = false;
			$scope.checkPermissionData = {};
			PermissionService.haveGlobalPermission('connector-create').then(function (
				response
			) {
				$scope.create_authorised = response.data;
			});

			$scope.bulkDelete = false;
			$scope.showDeleteModal = function (obj) {
				$scope.objToDelete = obj;
				$scope.bulkDelete = false;
				$scope.checkPermissionData.elementId = obj.id;
				$scope.checkPermissionData.type = 'connector';
				$scope.checkPermissionData.action = 'delete';
				$scope.checkPermissionData.actionIfPermitted = $scope.doShowDeleteModal;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.editConnector = function (obj) {
				$scope.objToEdit = obj;
				$scope.checkPermissionData.elementId = obj.id;
				$scope.checkPermissionData.type = 'connector';
				$scope.checkPermissionData.action = 'edit';
				$scope.checkPermissionData.actionIfPermitted = $scope.goToEdit;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.goToEdit = function () {
				$state.go('connectors-edit', {
					id: $scope.objToEdit.id,
					type: $scope.objToEdit.connector_type,
				});
			};

			$scope.deleteElementData = {};
			$scope.doShowDeleteModal = function (count) {
				$scope.deleteElementData = {
					label: $scope.objToDelete ? $scope.objToDelete.lc : undefined,
					doDelete: $scope.bulkDelete
						? $scope.deleteBulkConnectors
						: $scope.deleteConnector,
					showConfirmDeleteElement: true,
					bulk: $scope.bulkDelete,
					count: count,
				};
			};

			$scope.deleteBulkConnectorsModal = function () {
				$scope.bulkDelete = true;
				$scope.doShowDeleteModal($scope.selectedElems.length);
			};

			$scope.deleteBulkConnectors = function () {
				let connectorIds = _.map($scope.selectedElems, function (con) {
					return con.id;
				});
				ConnectorService.deleteConnectors(connectorIds)
					.then(function () {
						if ($scope.connector_authorised) {
							$scope.getGridData();
							$scope.gridInstance.clearSelection();
						}
						toaster.pop(
							'success',
							toasterPopSuccess,
							toasterPopDeleteConnectors
						);
					})
					.catch(function (e) {
						if (
							e &&
							e.data &&
							e.data.code == '40' &&
							$scope.connector_authorised
						) {
							$scope.getGridData();
							$scope.gridInstance.clearSelection();
						}
					});
			};

			function deleteConnectorSuccess(lib) {
				toaster.pop(
					'success',
					toasterPopSuccess,
					toasterPopDeleteConnector +
						' ' +
						lib +
						' ' +
						toasterPopDeleteConnectorSuccess
				);
				for (let j in $scope.dataGridOptions.dataSource) {
					if (
						$scope.dataGridOptions.dataSource[j].id == $scope.objToDelete.id
					) {
						$scope.dataGridOptions.dataSource.splice(j, 1);
						$scope.gridInstance.refresh();
						break;
					}
				}
			}

			$scope.deleteConnector = function () {
				if (
					$scope.objToDelete.connector_type == SQL_CONNECTOR ||
					$scope.objToDelete.connector_type == MONGODB_CONNECTOR ||
					$scope.objToDelete.connector_type == NEO4J_CONNECTOR ||
					$scope.objToDelete.connector_type == TRINO_CONNECTOR
				) {
					ConnectorV2Service.deleteConnector($scope.objToDelete.id)
						.then(function (response) {
							deleteConnectorSuccess(toasterPopDeleteConnectorDB);
						})
						.catch(function (e) {
							if (e && e.data && e.data.code == '40') {
								$scope.gridInstance.clearSelection();
							}
						});
				} else {
					ConnectorV2Service.deleteConnector($scope.objToDelete.id).then(
						function (response) {
							deleteConnectorSuccess($scope.objToDelete.connector_type);
						}
					);
				}
			};

			$scope.moveOrCopyData = {};
			$scope.moveOrCopyElementToProject = function () {
				let connectorIds = _.map($scope.selectedElems, function (con) {
					return con.id;
				});
				$scope.moveOrCopyData = {
					elements: connectorIds,
					type: 'connector',
					showMoveCopy: true,
				};
			};
			$scope.moveOrCopyOneElementToProject = function (elementId) {
				$scope.moveOrCopyData = {
					elements: [elementId],
					type: 'connector',
					showMoveCopy: true,
				};
			};

			function getListConnectors() {
				let deferred = $q.defer();
				ConnectorService.getConnectorsList(
					undefined,
					undefined,
					undefined,
					undefined,
					$scope.showCurrentProjectOnly,
					$scope.activeElementsOnly
				).then(
					function (response) {
						deferred.resolve(response.data);
					},
					function (err) {
						$log.error(err);
						deferred.reject(err);
					}
				);
				return deferred.promise;
			}

			$scope.showGrid = false;
			$scope.getGridData = function () {
				$scope.showGrid = false;
				getListConnectors().then(function (data) {
					if (data != undefined) {
						let content = data;
						$scope.connectors = [];
						$scope.tags = [];
						let tags = [];
						for (let i in content) {
							$scope.connectors.push({
								id: content[i].id,
								code: content[i].metadata.code,
								lc: content[i].metadata.label,
								desc: content[i].metadata.description,
								connector_type: content[i].connector_type,
								tags: content[i].metadata.tags,
								icon_id: content[i].metadata.icon_id,
								imported: content[i].metadata.imported,
								tagAsArray: $rootScope.mapTags(content[i].metadata.tags),
								creationDate: $rootScope.getDateTimeWithPattern(
									content[i].metadata.creation_date
								),
								updateDate: $rootScope.getDateTimeWithPattern(
									content[i].metadata.update_date
								),
								createdBy: content[i].metadata.created_by,
								updatedBy: content[i].metadata.updated_by,
								project: content[i].metadata.project,
							});
							tags = _.union(tags, content[i].metadata.tags);
						}

						for (let i in tags) {
							if (_.find($scope.tags, { id: tags[i].id }) == null) {
								$scope.tags.push({ id: tags[i].id, label: tags[i].code });
							}
						}
						$scope.gridData = angular.copy($scope.connectors);
						$scope.dataGridOptions.dataSource = $scope.gridData;
						$scope.showGrid = true;
					}
				});
			};

			// Filter on imported property
			// Binded to imported checkbox
			$scope.filterImported = function () {
				if ($scope.importedOnly) {
					$scope.gridInstance.filter(['imported', '=', true]);
				} else {
					$scope.gridInstance.clearFilter('dataSource');
				}
			};

			function init() {
				$scope.active = true;
				PermissionService.haveGlobalPermission('connector').then(function (
					response
				) {
					$scope.connector_authorised = response.data;
					if ($scope.connector_authorised) {
						$scope.getGridData();
					}
				});
			}

			// Get DxGrid dataGridOptions
			$scope.disableAllSelectedElems = true;
			DcElementListService.getDcElementDxList($scope, 'connector', false);
			init();
		},
	])
	.controller('ConnectorEditController', [
		'$scope',
		'$rootScope',
		'$stateParams',
		'toaster',
		'$state',
		'EntiteFileService',
		'PAGINATIONS_SIZE',
		'PAGINATIONS_SIZES',
		'$timeout',
		'ConnectorService',
		'ConnectorV2Service',
		'DepotService',
		'$filter',
		'$window',
		'gettextCatalog',
		'ModalService',
		function (
			$scope,
			$rootScope,
			$stateParams,
			toaster,
			$state,
			EntiteFileService,
			PAGINATIONS_SIZE,
			PAGINATIONS_SIZES,
			$timeout,
			ConnectorService,
			ConnectorV2Service,
			DepotService,
			$filter,
			$window,
			gettextCatalog,
			ModalService
		) {
			const HTTP_CONNECTOR = 'HTTP';
			const SQL_CONNECTOR = 'SQL';
			const SFTP_CONNECTOR = 'SFTP';
			const S3_CONNECTOR = 'S3';
			const HDFS_CONNECTOR = 'HDFS';
			const MONGODB_CONNECTOR = 'MONGODB';
			const NEO4J_CONNECTOR = 'NEO4J';
			const TRINO_CONNECTOR = 'TRINO';

			$scope.helpTitleTra = gettextCatalog.getString('Aide Connecteurs');

			let toasterPopSuccess = gettextCatalog.getString('Succès');
			let createConnectorTra = gettextCatalog.getString(
				'Création du Connecteur'
			);
			let updateConnectorTra = gettextCatalog.getString(
				'Modification du Connecteur'
			);
			let deleteConnectorTra = gettextCatalog.getString(
				'Suppression du Connecteur'
			);
			let updateOrCreateConnectorDone = gettextCatalog.getString('effectuée');

			let toasterPopError = gettextCatalog.getString('Erreur');
			let toasterPopConnectorErrorMessage = gettextCatalog.getString(
				'Le type de Connecteur est obligatoire !'
			);
			let toasterPopValidConnection =
				gettextCatalog.getString('Connexion Valide');
			let toasterPopErrorConnection = gettextCatalog.getString(
				'La connexion a échoué'
			);

			let toasterConnectorHost = gettextCatalog.getString('hôte');
			let toasterConnectorPort = gettextCatalog.getString('port');
			let toasterConnectorBaseName = gettextCatalog.getString('nom_de_la_base');

			$scope.metadata = {};
			$scope.metadata.code = '';
			$scope.metadata.actif = true;
			$scope.metadata.tags = [];

			let connectorDataBaseType = gettextCatalog.getString('Base de données');

			$scope.connectorsTypes = [
				{ value: SQL_CONNECTOR, label: connectorDataBaseType },
				{ value: HTTP_CONNECTOR, label: HTTP_CONNECTOR },
				{ value: S3_CONNECTOR, label: 'S3 / MinIO' },
				{
					value: SFTP_CONNECTOR,
					label: SFTP_CONNECTOR,
				},
				{ value: HDFS_CONNECTOR, label: HDFS_CONNECTOR },
			];
			$scope.dbConnecteurInputTypes = [
				{ value: 'DEDUCTED', label: gettextCatalog.getString('deducted') },
				{ value: 'FREE', label: gettextCatalog.getString('free') },
			];

			$scope.httpAuthTypes = [
				{ value: 'NONE', label: gettextCatalog.getString('Aucune') },
				{ value: 'BASIC', label: gettextCatalog.getString('Basique') },
				{ value: 'OAUTH2_CLIENT_CREDENTIALS', label: gettextCatalog.getString('http.auth.type.oauth2.clientCredentials') },
				{ value: 'OAUTH2_PASSWORD', label: gettextCatalog.getString('http.auth.type.oauth2.password') }
			];

			$scope.httpAuthClientMethods = [
				{ value: 'BASIC', label: gettextCatalog.getString('http.auth.method.basic') },
				{ value: 'POST', label: gettextCatalog.getString('http.auth.method.post') },
			];

			$scope.bdTypes = [
				{ value: 'mariaDb', label: 'MariaDB' },
				{ value: 'mongoDb', label: 'MongoDB' },
				{
					value: 'mySql',
					label: 'MySQL',
				},
				{
					value: 'neo4j',
					label: ' Neo4j',
				},
				{ value: 'oracle', label: 'Oracle' },
				{ value: 'pgSql', label: 'PostgreSQL' },
				{
					value: 'sqlServer',
					label: ' SQL Server',
				},
				{
					value: 'trino',
					label: 'Trino',
				},
			];

			$scope.accessModes = [
				{ value: 'READ_ONLY', label: gettextCatalog.getString('connector.mode.readonly') },
				{ value: 'READ_WRITE', label: gettextCatalog.getString('connector.mode.readwrite') },
				{ value: 'WRITE_ONLY', label: gettextCatalog.getString('connector.mode.writeonly') },
			];

			$scope.isNewConnector = true;

			$scope.saveButtonDisabled = true;
			$scope.permissionData = {};

			$scope.checkPermissionData = {};

			$scope.showPermissions = function () {
				$scope.checkPermissionData.elementId = $scope.connector.id;
				$scope.checkPermissionData.type = 'connector';
				$scope.checkPermissionData.action = 'permissions';
				$scope.checkPermissionData.actionIfPermitted = $scope.doShowPermissions;
				$scope.checkPermissionData.showPermissionCheck = true;
			};

			$scope.doShowPermissions = function () {
				$scope.permissionData.metadataId = $scope.connector.metadata.id;
				$scope.permissionData.type = 'connector';
				$scope.permissionData.elementId = $scope.connector.id;
				$scope.permissionData.lib = $scope.connector.metadata.label;
				$scope.permissionData.showElementPermissions = true;
			};

			$scope.resetBdData = function () {
				$scope.metadataDb = {};
				$scope.metadataDb.code = '';
				$scope.metadataDb.actif = true;
				$scope.metadataDb.tags = [];
				$scope.extraction = {};
			};

			let catchErrors = function (error) {
				$scope.savingInProgress = false;
			};

			function connectorTypeLib(type) {
				switch (type) {
					case SFTP_CONNECTOR:
						return SFTP_CONNECTOR;
					case SQL_CONNECTOR:
						return connectorDataBaseType;
					case HTTP_CONNECTOR:
						return HTTP_CONNECTOR;
					case HDFS_CONNECTOR:
						return HDFS_CONNECTOR;
					case S3_CONNECTOR:
						return S3_CONNECTOR;
					default:
						return '';
				}
			}

			function createDepotSuccess(returnToList, responseData, type) {
				toaster.pop(
					'success',
					toasterPopSuccess,
					createConnectorTra +
						' ' +
						connectorTypeLib(type) +
						' ' +
						updateOrCreateConnectorDone
				);
				if (returnToList) {
					$timeout(function () {
						$scope.savingInProgress = false;
						$state.go('connectors');
					}, 300);
				} else {
					$timeout(function () {
						$scope.savingInProgress = false;
						$state.go('connectors-edit', { id: responseData.id, type: type });
					}, 300);
				}
			}

			function saveDepotSuccess(returnToList, responseData, type) {
				toaster.pop(
					'success',
					toasterPopSuccess,
					updateConnectorTra +
						' ' +
						connectorTypeLib(type) +
						' ' +
						updateOrCreateConnectorDone
				);
				if (returnToList) {
					$timeout(function () {
						$state.go('connectors');
					}, 300);
				}
				$scope.savingInProgress = false;
			}

			$scope.showConfirmationModal = function () {
				$('#confirmationModal').modal('show');
			};

			$scope.redirectionToList = function () {
				$('#confirmationModal').modal('hide');
				$timeout(function () {
					$state.go('connectors');
				}, 300);
			};
			$scope.connector = {};

			$scope.savingInProgress = false;
			$scope.saveConnector = function () {
				if (!$scope.isNewConnector) {
					$scope.checkPermissionData.elementId = $scope.connector.id;
					$scope.checkPermissionData.type = 'connector';
					$scope.checkPermissionData.action = 'edit';
					$scope.checkPermissionData.actionIfPermitted = $scope.save;
					$scope.checkPermissionData.showPermissionCheck = true;
				} else {
					$scope.save();
				}
			};

			$scope.save = function (returnToList) {
				if (
					$scope.connector.connector_type == SQL_CONNECTOR ||
					$scope.connector.connector_type == MONGODB_CONNECTOR ||
					$scope.connector.connector_type == NEO4J_CONNECTOR ||
					$scope.connector.connector_type == TRINO_CONNECTOR
				) {
					$scope.saveDbConnector(returnToList);
				} else if ($scope.connector.connector_type == HTTP_CONNECTOR) {
					$scope.saveHttpConnector(returnToList);
				} else if ($scope.connector.connector_type == S3_CONNECTOR) {
					$scope.saveS3Connector(returnToList);
				} else if ($scope.connector.connector_type == SFTP_CONNECTOR) {
					$scope.saveSFTPConnector(returnToList);
				} else if ($scope.connector.connector_type == HDFS_CONNECTOR) {
					$scope.saveHdfsConnector(returnToList);
				} else {
					toaster.pop(
						'error',
						toasterPopError,
						toasterPopConnectorErrorMessage
					);
				}
			};

			$scope.saveAndReturnToList = function () {
				$scope.save(true);
			};

			$scope.dataModel = {};
			$scope.dataModel.save = $scope.saveAndReturnToList;
			$scope.dataModel.redirectionToList = $scope.redirectionToList;

			$scope.saveDbConnector = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color != undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				let dbType;
				if ($scope.connector.type == 'mongoDb') {
					dbType = MONGODB_CONNECTOR;
				} else if ($scope.connector.type == 'neo4j') {
			 		dbType = NEO4J_CONNECTOR;
			 	} else if ($scope.connector.type == 'trino') {
			 		dbType = TRINO_CONNECTOR;
				} else {
				  dbType = SQL_CONNECTOR;
				}
				$scope.dbConnector = getConnectorV2Dto(dbType, $scope.connector, $scope.metadata);
				setSelectedSqlInputType($scope.dbConnector);
				$scope.savingInProgress = true;
				if ($scope.isNewConnector) {
					ConnectorV2Service.createConnector($scope.dbConnector)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, dbType);
						})
						.catch(catchErrors);
				} else {
					ConnectorV2Service.editConnector($scope.connector.id, $scope.dbConnector)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, dbType);
						})
						.catch(catchErrors);
				}
			};

			function setSelectedSqlInputType(connector) {
				if ($scope.connector.connection_string_input_type=='DEDUCTED') {
					delete connector.full_url;
				}
				if ($scope.connector.connection_string_input_type=='FREE') {
					delete connector.host;
					delete connector.port;
					delete connector.additional_params;
					delete connector.db_name;
				}
			}

			$scope.saveSFTPConnector = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color != undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				$scope.sftpConnector = getConnectorV2Dto(SFTP_CONNECTOR, $scope.connector, $scope.metadata);
				$scope.savingInProgress = true;

				if ($scope.isNewConnector) {
					ConnectorV2Service.createConnector($scope.sftpConnector)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, SFTP_CONNECTOR);
						})
						.catch(catchErrors);
				} else {
					ConnectorV2Service.editConnector(
						$scope.connector.id,
						$scope.sftpConnector
					)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, SFTP_CONNECTOR);
						})
						.catch(catchErrors);
				}
			};

			$scope.saveHttpConnector = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color != undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				$scope.httpConnector = getConnectorV2Dto(HTTP_CONNECTOR, $scope.connector, $scope.metadata);
				$scope.savingInProgress = true;

				if ($scope.isNewConnector) {
					ConnectorV2Service.createConnector($scope.httpConnector)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, HTTP_CONNECTOR);
						})
						.catch(catchErrors);
				} else {
					ConnectorV2Service.editConnector(
						$scope.connector.id,
						$scope.httpConnector
					)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, HTTP_CONNECTOR);
						})
						.catch(catchErrors);
				}
			};

			$scope.saveS3Connector = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color != undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				$scope.s3Connector = getConnectorV2Dto(S3_CONNECTOR, $scope.connector, $scope.metadata);
				$scope.savingInProgress = true;

				if ($scope.isNewConnector) {
					ConnectorV2Service.createConnector($scope.s3Connector)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, S3_CONNECTOR);
						})
						.catch(catchErrors);
				} else {
					ConnectorV2Service.editConnector(
						$scope.connector.id,
						$scope.s3Connector
					)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, S3_CONNECTOR);
						})
						.catch(catchErrors);
				}
			};

			$scope.saveHdfsConnector = function (returnToList) {
				$('#confirmationModal').modal('hide');

				// set metadata
				for (let t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color =
						$scope.metadata.tags[t].color != undefined
							? $scope.metadata.tags[t].color
							: '#dbf5d1';
				}

				$scope.hdfsConnector = getConnectorV2Dto(HDFS_CONNECTOR, $scope.connector, $scope.metadata);
				$scope.savingInProgress = true;

				if ($scope.isNewConnector) {
					ConnectorV2Service.createConnector($scope.hdfsConnector)
						.then(function (response) {
							createDepotSuccess(returnToList, response.data, HDFS_CONNECTOR);
						})
						.catch(catchErrors);
				} else {
					ConnectorV2Service.editConnector(
						$scope.connector.id,
						$scope.hdfsConnector
					)
						.then(function (response) {
							saveDepotSuccess(returnToList, response.data, HDFS_CONNECTOR);
						})
						.catch(catchErrors);
				}
			};

			function getConnectorV2Dto(type, connector, metadata) {
				if (type == HDFS_CONNECTOR) {
					let params = {};
					angular.forEach($scope.paramsKeys, function (value, key) {
						params[value] = $scope.paramsValues[key];
					});
					return {
						id: angular.copy(connector.id),
						metadata: angular.copy(metadata),
						connector_type: angular.copy(connector.connector_type),
						mode: angular.copy(connector.mode),
						host: angular.copy(connector.host),
						port: angular.copy(connector.port),
						params: angular.copy(params)
					}
				} else if (type == S3_CONNECTOR) {
					return {
						id: angular.copy(connector.id),
						metadata: angular.copy(metadata),
						connector_type: angular.copy(connector.connector_type),
						mode: angular.copy(connector.mode),
						access_key: angular.copy(connector.access_key),
						secret_key: angular.copy(connector.secret_key),
						end_point: angular.copy(connector.end_point),
						bucket: angular.copy(connector.bucket),
						proxy_url: angular.copy(connector.proxy_url),
					}
				} else if (type == HTTP_CONNECTOR) {
					return {
						id: angular.copy(connector.id),
						metadata: angular.copy(metadata),
						connector_type: angular.copy(connector.connector_type),
						mode: angular.copy(connector.mode),
						url: angular.copy(connector.url),
						proxy_url: angular.copy(connector.proxy_url),
						auth: angular.copy(connector.auth),
						headers: angular.copy(connector.headers),
						ignore_certificate_verification:
							angular.copy(connector.ignore_certificate_verification),
					};
				} else if (type == SFTP_CONNECTOR) {
					if ($scope.sftpSSH) {
						return {
							id: angular.copy(connector.id),
							metadata: angular.copy(metadata),
							connector_type: angular.copy(connector.connector_type),
							mode: angular.copy(connector.mode),
							host: angular.copy(connector.host),
							port: angular.copy(connector.port),
							ssh_access: {
								username: connector.username,
								secret_phrase: connector.password,
								ssh_key: connector.ssh_access.ssh_key
							}
						}
					} else {
						return {
							id: angular.copy(connector.id),
							metadata: angular.copy(metadata),
							connector_type: angular.copy(connector.connector_type),
							mode: angular.copy(connector.mode),
							host: angular.copy(connector.host),
							port: angular.copy(connector.port),
							credentials: {
								username: connector.username,
								password: connector.password
							}
						}
					}
				} else if (type == MONGODB_CONNECTOR ||
					type == NEO4J_CONNECTOR ||
					type == TRINO_CONNECTOR ||
					type == SQL_CONNECTOR
				) {
					return {
						id: angular.copy(connector.id),
						metadata: angular.copy(metadata),
						connector_type: angular.copy(connector.connector_type),
						mode: angular.copy(connector.mode),
						db_name: angular.copy(connector.db_name),
						host: angular.copy(connector.host),
						port: angular.copy(connector.port),
						password: angular.copy(connector.password),
						db_type: angular.copy(connector.type),
						username: angular.copy(connector.username),
						additional_params: angular.copy(connector.additional_params),
						full_url: angular.copy(connector.full_url),
						connection_string_input_type: angular.copy(connector.connection_string_input_type)
					}
				}
			}

			function initConnectorData(data, connectorType) {
				if (
					connectorType == 'DB' ||
					connectorType == MONGODB_CONNECTOR ||
					connectorType == NEO4J_CONNECTOR ||
					connectorType == TRINO_CONNECTOR
				) {
					connectorType = SQL_CONNECTOR;
				}
				$scope.connector = data;
				$scope.connector.id = $scope.isNewConnector
					? undefined
					: $scope.connector.id;
				$scope.metadata = $scope.isNewConnector
					? $scope.metadata
					: $scope.connector.metadata;
				$scope.metadataLoaded = true;
				$scope.connector.connector_type = connectorType;
				if ($scope.connector.connector_type == SQL_CONNECTOR) {
					$scope.connector.connection_string_input_type =  $scope.isNewConnector ? 'DEDUCTED' : $scope.connector.connection_string_input_type;
				}
				else if ($scope.connector.connector_type == SFTP_CONNECTOR) {
					if ($scope.connector.ssh_access) {
						$scope.connector.username = $scope.connector.ssh_access.username;
					} else if ($scope.connector.credentials) {
						$scope.connector.username = $scope.connector.credentials.username;
					}
				} else if (
					$scope.connector.connector_type == HTTP_CONNECTOR &&
					$scope.connector.bac
				) {
					$scope.connector.username = $scope.connector.bac.username;
				}
			}

			function init() {
				if (
					($stateParams.id && $stateParams.type) ||
					($stateParams.duplicatedId && $stateParams.type)
				) {
					// edit
					$scope.isNewConnector = $stateParams.duplicatedId != undefined;
					$scope.connector = {};
					$scope.isSSH();
					let connectorId =
						$stateParams.id != undefined
							? $stateParams.id
							: $stateParams.duplicatedId;
					$scope.savingInProgress = false;
					ConnectorV2Service.getConnectorById(connectorId).then(function (
						response
					) {
						initConnectorData(response.data, $stateParams.type);
						if ($stateParams.type == SQL_CONNECTOR ||
							$stateParams.type == 'DB' ||
							$stateParams.type == MONGODB_CONNECTOR ||
							$stateParams.type == NEO4J_CONNECTOR ||
							$stateParams.type == TRINO_CONNECTOR
						) {
							$scope.connector.type = $scope.connector.db_type;
							delete $scope.connector.db_type;
							$scope.getConnectionString();
						} else if ($stateParams.type == SFTP_CONNECTOR) {
							$scope.isSSH();
						} else if ($stateParams.type == HDFS_CONNECTOR) {
							getHdfsConnectorParams();
						}
					});
				} else {
					$scope.isNewConnector = true;
					$scope.metadataLoaded = true;
					$scope.isSSH();
				}
			}

      $scope.checkConnectionErrors = {};

			/**
			 * Handles the HTTP responses from the connection check API.
       * The function expects the API to return an object with different keys like those below:
       * {
       *   "httpConnectorTokenEndpoint": "OK" | "KO" | "NOT_CHECKED",
       *   "httpConnectorURL": "OK" | "KO" | "NOT_CHECKED",
       *   "httpConnectorProxyURL": "OK" | "KO" | "NOT_CHECKED"
       * }
       * For a HTTP connector, there are 3 keys, for the other connectors there is only one key
       * Behavior:
       * - If all values are "OK", shows a success message.
       * - If all values are "NOT_CHECKED", shows a generic error message.
       * - If any value is "KO", shows an error message for each failed key.
       *
       * @param {Object} response - The HTTP response object from the API call.
			 */
			let connectionV2ResponseHandler = function (type, response) {
				let data = response.data;
				let values = Object.values(data);
				let keys = Object.keys(data);

				if (type == HTTP_CONNECTOR) {
					let allOk = values.every(v => v === "OK" || v === "NOT_CHECKED");
					let allNotChecked = values.every(v => v === "NOT_CHECKED");
					if(allOk) {
						toaster.pop('success', toasterPopSuccess, toasterPopValidConnection);
					} else if (allNotChecked) {
						toaster.pop('error', toasterPopError, toasterPopErrorConnection);
					} else {
						 keys.forEach((key) => {
								if (data[key] === "KO") {
										let errorCode = "http.connector.check." + key +".error";
										let errorMsg = gettextCatalog.getString(errorCode);
										// mark the filed as in error
										$scope.checkConnectionErrors[key] = true;
										// show the message
										toaster.pop('error', toasterPopError, errorMsg);
								}
						});
					}
				} else {
					let isOk = values[0] === "OK";
					if (isOk) {
						toaster.pop('success', toasterPopSuccess, toasterPopValidConnection);
					} else {
						toaster.pop('error', toasterPopError, toasterPopErrorConnection);
					}
				}
			};

			$scope.testConnection = function () {
				$scope.checkConnectionErrors = {};
				let connector = getConnectorV2Dto($scope.connector.connector_type, $scope.connector, $scope.metadata);
				ConnectorV2Service.checkConnection(connector).then(function (response) {
					connectionV2ResponseHandler($scope.connector.connector_type, response);
				});
			};

			$scope.onDbTypeChange = function () {
				$scope.getConnectionString();
				if ($scope.connector.type == 'trino') {
					$scope.connector.mode = 'READ_ONLY';
				}
			}

			$scope.getConnectionString = function () {
				$scope.generatedconnectionChaine = '';
				let host =
					$scope.connector.host != undefined
						? $scope.connector.host
						: toasterConnectorHost;
				let port =
					$scope.connector.port != undefined
						? $scope.connector.port
						: toasterConnectorPort;
				let dbName =
					$scope.connector.db_name != undefined
						? $scope.connector.db_name
						: toasterConnectorBaseName;
				let username =
					$scope.connector.username != undefined
						? $scope.connector.username
						: 'username';
				let secureKey = '*******';
				switch ($scope.connector.type) {
					case 'oracle':
						$scope.generatedconnectionChaine =
							'jdbc:oracle:thin:@//' + host + ':' + port + '/' + dbName;
						break;
					case 'sqlServer':
						$scope.generatedconnectionChaine =
							'jdbc:sqlserver://' +
							host +
							':' +
							port +
							';databaseName=' +
							dbName;
						break;
					case 'pgSql':
						$scope.generatedconnectionChaine =
							'jdbc:postgresql://' + host + ':' + port + '/' + dbName;
						break;
					case 'mySql':
						$scope.connector.additional_params = $scope.isNewConnector
							? 'nullNamePatternMatchesAll=true&useUnicode=true&useJDBCCompliantTimezoneShift=true&useLegacyDatetimeCode=false&serverTimezone=UTC&zeroDateTimeBehavior=convertToNull'
							: $scope.connector.additional_params;
						$scope.generatedconnectionChaine =
							'jdbc:mysql://' + host + ':' + port + '/' + dbName;
						break;
					case 'mariaDb':
						$scope.generatedconnectionChaine =
							'jdbc:mariadb://' + host + ':' + port + '/' + dbName;
						break;
					case 'neo4j':
						$scope.generatedconnectionChaine = 'bolt://' + host + ':' + port;
						break;
					case 'mongoDb':
						$scope.generatedconnectionChaine =
							'mongodb://' +
							username +
							':' +
							secureKey +
							'@' +
							host +
							':' +
							port +
							'/' +
							dbName;
						break;
					case 'trino':
						$scope.connector.additional_params = $scope.isNewConnector
							? 'SSL=false'
							: $scope.connector.additional_params;
						$scope.generatedconnectionChaine =
							'jdbc:trino://' +
							host + ':' + port + '/' +
							dbName + '?' +
							'user=' + username;
						break;
					default:
						$scope.generatedconnectionChaine = '';
				}
			};
			$scope.deleteElementData = {};
			$scope.showDeleteConModal = function () {
				$scope.objToDelete = $scope.connector;
				$scope.deleteElementData = {
					label: $scope.connector.metadata.label,
					doDelete: $scope.deleteConnector,
					showConfirmDeleteElement: true,
				};
			};

			$scope.deleteConnector = function () {
				ConnectorV2Service.deleteConnector($scope.objToDelete.id).then(
					function (response) {
						if (
							$scope.objToDelete.connector_type == SQL_CONNECTOR ||
							$scope.objToDelete.connector_type == MONGODB_CONNECTOR ||
							$scope.objToDelete.connector_type == NEO4J_CONNECTOR
						) {
							showDeleteSuccessAndReturn('Base de données');
						} else {
							showDeleteSuccessAndReturn($scope.objToDelete.connector_type);
						}
					}
				);
			};

			function showDeleteSuccessAndReturn(type) {
				toaster.pop(
					'success',
					toasterPopSuccess,
					deleteConnectorTra + ' ' + type + ' ' + updateOrCreateConnectorDone
				);
				$timeout(function () {
					$state.go('connectors');
				}, 300);
			}

			$scope.showTable = false;
			$scope.getLinkedDepotTable = function () {
				$scope.showTable = true;
			};

			$scope.depotListConf = {};
			$scope.depotListConf.disableAllSelectedElems = true;

			$scope.elementGraphData = {};
			$scope.showHdhGraph = function () {
				$scope.elementGraphData.centeredElementLabel =
					$scope.connector.metadata.label;
				$scope.elementGraphData.centeredElementType = 'CONNECTOR';
				$scope.elementGraphData.centeredElementId = $scope.connector.id;
				$scope.elementGraphData.showHdhElementGraph = true;
			};

			$scope.sftpSSH = false;
			$scope.isSSH = function () {
				$scope.sftpSSH =
					$scope.connector &&
					$scope.connector.ssh_access != undefined &&
					$scope.connector.credentials == undefined;
				$scope.resetSftpSecMode();
			};

			$scope.resetSftpSecMode = function () {
				if ($scope.connector) {
					if ($scope.sftpSSH) {
						$scope.connector.ssh_access = $scope.connector.ssh_access
							? $scope.connector.ssh_access
							: {};
						$scope.connector.credentials = null;
					} else {
						$scope.connector.ssh_access = null;
						$scope.connector.credentials = $scope.connector.credentials
							? $scope.connector.credentials
							: {};
					}
				}
			};

			$scope.changeHttpAuthMode = function () {
				if ($scope.connector && $scope.connector.auth) {
					if ($scope.connector.auth.type == 'BASIC') {
						$scope.connector.auth = $scope.connector.auth
							? $scope.connector.auth
							: {type: 'BASIC'};
					} else  if  ($scope.connector.auth.type == 'OAUTH2_CLIENT_CREDENTIALS') {
							$scope.connector.auth.client_auth_method = $scope.connector.auth.client_auth_method ?  $scope.connector.auth.client_auth_method : 'NONE';
					} else {
						$scope.connector.auth = $scope.connector.auth
							? $scope.connector.auth
							: {type: 'NONE'};
					}
				}
			};

			$scope.onSelectedConnectorType = function () {
				$scope.isSSH()
				if ($scope.isNewConnector)
				{
					if ($scope.connector.connector_type == SQL_CONNECTOR)
					{
						$scope.connector.connection_string_input_type = 'DEDUCTED';
					}
					else
					{
						delete $scope.connector.connection_string_input_type;
					}
					// If the connector is HTTP, it must be READ_ONLY. Otherwise, default value is READ_WRITE.
					$scope.connector.mode = $scope.connector.connector_type == HTTP_CONNECTOR ? 'READ_ONLY' : 'READ_WRITE';
				}
			};

			$scope.metadataConfig = {
				htmlId: 'connector',
			};
			$scope.paramsKeys = {};
			$scope.paramsValues = {};
			$scope.addHdfsParamValue = function () {
				$scope.paramsKeys =
					$scope.paramsKeys != undefined ? $scope.paramsKeys : {};
				$scope.paramsValues =
					$scope.paramsValues != undefined ? $scope.paramsValues : {};
				let key = _.uniqueId('params_');
				$scope.paramsKeys[key] = '';
				$scope.paramsValues[key] = '';
			};

			$scope.deleteHdfsParamValue = function (index) {
				delete $scope.paramsKeys[index];
				delete $scope.paramsValues[index];
			};

			let getHdfsConnectorParams = function () {
				$scope.paramsKeys = {};
				$scope.paramsValues = {};
				angular.forEach($scope.connector.params, function (value, key) {
					let uniqueKey = _.uniqueId('params_');
					$scope.paramsKeys[uniqueKey] = key;
					$scope.paramsValues[uniqueKey] = value;
				});
			};

			$scope.openFileManagerModal = function () {
				if (!$scope.connector && !$scope.connector.connector_type) {
					return;
				}
				let	connector = angular.copy($scope.connector);
				let connectorType = $scope.connector.connector_type;
				let title = gettextCatalog.getString(
					'connector.remote.files.explorer',
					{
						connectorType: $filter('connectorTranslator')(connectorType),
						connectorLabel: $scope.metadata.label,
					}
				);
				var locals = {
					title: title,
					connector: connector,
					type: connectorType,
				};

				ModalService.open({
					controllerAs: 'vm',
					bindToController: true,
					templateUrl:
						'./src/components/modules/connector/remote-file-explorer/remote-file-explorer.html',
					controller: 'RemoteFilesExplorerController',
					disableBackdrop: true,
					locals: locals,
				}).then(function (path) {
					$scope.depot.path = path;
				});
			};

			$scope.addHttpHeaderValue = function () {
				$scope.connector.headers =
					$scope.connector.headers != undefined
						? $scope.connector.headers
						: {};
				let length = Object.keys($scope.connector.headers).length;
				$scope.connector.headers['key' + length] =
					'value' + length;
			}

			$scope.deleteHttpHeaderValue = function (index) {
				let objIndex = 0;
				for (let i in $scope.connector.headers) {
					if (objIndex === index) {
						delete $scope.connector.headers[i];
						break;
					}

					objIndex++;
				}
			};

			$scope.addTokenRequestParam = function () {
				$scope.connector.auth.token_request_params =
					$scope.connector.auth.token_request_params != undefined
						? $scope.connector.auth.token_request_params
						: {};
				let length = Object.keys($scope.connector.auth.token_request_params).length;
				$scope.connector.auth.token_request_params['key' + length] =
					'value' + length;
			}

			$scope.deleteTokenRequestParam = function (index) {
				let objIndex = 0;
				for (let i in $scope.connector.auth.token_request_params) {
					if (objIndex === index) {
						delete $scope.connector.auth.token_request_params[i];
						break;
					}

					objIndex++;
				}
			};

			$scope.updateTokenRequestParamKey = function (key, index) {
				let keys = Object.keys($scope.connector.auth.token_request_params);
				let oldKey = keys[index];
				$scope.connector.auth.token_request_params = keys.reduce((acc, val) => {
					if (val === oldKey) {
						acc[key] = $scope.connector.auth.token_request_params[oldKey];
					} else {
						acc[val] = $scope.connector.auth.token_request_params[val];
					}
					return acc;
				}, {});
			};

			$scope.updateHttpHeaderKey = function (key, index) {
				let keys = Object.keys($scope.connector.headers);
				let oldKey = keys[index];
				$scope.connector.headers = keys.reduce((acc, val) => {
					if (val === oldKey) {
						acc[key] = $scope.connector.headers[oldKey];
					} else {
						acc[val] = $scope.connector.headers[val];
					}
					return acc;
				}, {});
			};

			$scope.showInfoModal = function (modalId) {
				$('#' + modalId).modal('show');
			};

			$scope.showIgnoreCertificateVerification = function (modalId) {
				$('#' + modalId).modal('show');
			};

			init();
		},
	]);
